import NiceModal, { useModal } from '@ebay/nice-modal-react'

import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import Modal from './modal'

interface BannerPopupModalProps {
  imgUrl: string
  onClick?: () => void
}

const BannerPopupModal = ({ imgUrl, onClick }: BannerPopupModalProps) => {
  const modal = useModal()

  return (
    <Modal
      id="banner-popup-modal"
      containerStyle="max-w-[500px] flex bg-transparent p-0 !border-0"
      zIndex={340}>
      <button
        className="flx-ctr absolute top-[-35px] right-[-5px] bg-white w-[30px] h-[30px] rounded-[50%]"
        onClick={() => closeModal(modal)}>
        <Icon className="w-3 h-3 fill-[#444]" id="close" />
      </button>
      <img
        className="w-full cursor-pointer rounded-[10px] xl:rounded-[20px]"
        src={imgUrl}
        alt="Banner"
        onClick={onClick ? onClick : () => closeModal(modal)}
      />
    </Modal>
  )
}

export default NiceModal.create(BannerPopupModal)
